// projects/humanresources-personnel/src/assets/i18n/*/hr-per-movement-return-status.json
export class HrPerMovementReturnStatusKey {
    private static readonly keyPrefix = "hrPerMovementReturnStatus";
    public static title = `${HrPerMovementReturnStatusKey.keyPrefix}.title`;
    public static pageHeader = `${HrPerMovementReturnStatusKey.keyPrefix}.pageHeader`;
    public static returnStatus = `${HrPerMovementReturnStatusKey.keyPrefix}.returnStatus`;
    public static suspensionType = `${HrPerMovementReturnStatusKey.keyPrefix}.suspensionType`;
    public static mandatoryDateField = `${HrPerMovementReturnStatusKey.keyPrefix}.mandatoryDateField`;
}
